import React from 'react';

import { StyledMenuMainOption } from './MenuMainOption.styled';

const MenuMainOption = ({ isSelected = false, isDisabled = false, option, onSelect}) => {
  return (
    <StyledMenuMainOption $selected={isSelected} $disabled={isDisabled} onClick={() => isDisabled ? false : onSelect(option)}>
      <div className='menu-option-decorator' />
      <div className='menu-option-name'>{option.name}</div>
      {!isSelected && (<div className='menu-option-filler'/>)}
    </StyledMenuMainOption>
  );
};

export default MenuMainOption;

